import React from 'react';
import PropTypes from 'prop-types';

import InputComponent from './Component';

class InputContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      isPopupVisible: false
    };

    this.handleAlertTriangleMouseEnter = () =>
      this.setState({ isPopupVisible: true });

    this.handleAlertTriangleMouseLeave = () =>
      this.setState({ isPopupVisible: false });
  }

  get showAlertTriangle () {
    return this.props.invalid;
  }

  render () {
    return (
      <InputComponent
        {...this.state}
        {...this.props}

        showAlertTriangle={this.showAlertTriangle}
        onAlertTriangleMouseEnter={this.handleAlertTriangleMouseEnter}
        onAlertTriangleMouseLeave={this.handleAlertTriangleMouseLeave}
      />
    );
  }
}

InputContainer.propTypes = {
  invalid: PropTypes.bool.isRequired
};

export default InputContainer;
